"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var EmailCard = function (_a) {
    var emailAddress = _a.emailAddress;
    return (React.createElement("div", { className: "u-spaceBottomSm" },
        React.createElement(teamsnap_ui_1.Icon, { name: "mail", mods: "u-spaceRightSm u-colorGrey" }),
        React.createElement("span", { className: "u-padTopSm" },
            React.createElement("a", { href: "mailto:" + emailAddress.email }, emailAddress.email))));
};
exports.default = EmailCard;
//# sourceMappingURL=email-info.js.map